/**
* 员工
*/
const employees = {
  
addEmployees: "/api/addEmployees",//添加员工
listEmployees: "/api/listEmployees",//查询员工
listEmployees2: "/api/listEmployees2",//查询员工
modifyEmployee: "/api/modifyEmployee",//编辑员工
deleteEmployees: "/api/deleteEmployees",//删除员工
}

export default employees